import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit, OnDestroy {
    requestType: 'capture' | 'authorize' = null;
    returnUrl = 'cs';
    submitButtonText = 'Пройти тест';
    loading = false;

    constructor(
        public lang: TranslateService
    ) {

    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
    }

}
